// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--b2b5a"};